import CachedIcon from '@mui/icons-material/Cached';
import { Card, CardContent, CardHeader, CircularProgress, IconButton, Typography } from "@mui/material";
import * as React from "react";
import { DemandCurrentDataModel } from "../../../models";

import { connect } from "react-redux";
import { actionCreators, ApplicationState, FetchState, selectors } from "../../../store";
import FetchHelper from '../../FetchHelper';
import { disabledRefreshAllBtnStyle, disabledRefreshSuccessIconStyles, enableRefreshAllBtnStyle, enableRefreshSuccessIconStyles, pollingColStyle, pollingColStyleTitle } from '../../styles';
import { formatTime } from '../../../utils';
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';

const NO_OF_POLLING_TOPIC = 1;
const params = {
    mainid: "",
    isRefreshAllBegin: 0,
    isRefreshAllCompleted: (status: number) => { },
    loadingRefreshAll: [false],
    setDisabledRefreshGroupBtn: (disabled: boolean, name: string) => { },
    isRefreshGroup: false,
    setRefreshGroup: (refreshGroup: boolean, name: string) => { },
    isDisbleRefeshBtn: true,
}
const fetchId = "DEMAND_CURRENT_DATA_FETCH";

type DemandCurrentDataProps = {
    defaultData: DemandCurrentDataModel | undefined;
};

export type PureDemandCurrentDataProps = DemandCurrentDataProps & ReturnType<typeof mapStateToProps> &
    typeof mapDispatchToProps & typeof params;

export const DemandCurrentData = (props: PureDemandCurrentDataProps) => {
    const { defaultData, fetchState, mainid, isRefreshAllBegin, loadingRefreshAll, isRefreshGroup, isDisbleRefeshBtn } = props;
    const { onError, onRefresh, isRefreshAllCompleted, setDisabledRefreshGroupBtn, setRefreshGroup } = props;
    const [demandCurrentData, setDemandCurrentData] = React.useState<DemandCurrentDataModel>(props.fetchState.data);
    const [refreshFlg, setRefreshFlg] = React.useState(false);
    const [isRefreshSuccess, setIsRefreshSuccess] = React.useState(false);

    // パラメータ設定
    const handleFetchParams = () => {
        const params = new Map<string, any>();
        const code = "PA";
        params.set("code", code);
        params.set("mainid", mainid);
        return params;
    }

    // デマンド現在値取得成功時
    const handleFetchSuccess = (data: any, isClickedRefreshBtn: boolean) => {
        setRefreshFlg(false);
        const resData = {
            mainid: data.mainid,
            occurrenceTime: formatTime(data.occurrence_time),
            currentKw: data.current_kw,
            predictKw: data.predict_kw,
            alarm2Kw: data.alarm2_kw,
            alarm1Kw: data.alarm1_kw,
            lastGetDatetime: data.last_get_datetime,
        } as DemandCurrentDataModel;
        setDemandCurrentData(resData);
        loadingRefreshAll[NO_OF_POLLING_TOPIC - 1] = false;
        setRefreshGroup(false, fetchId);
        isClickedRefreshBtn && setIsRefreshSuccess(true);
    };

    const handleError = (success: boolean, data: any, error: any) => {
        setRefreshFlg(false);
        onError(success, data, error);
        if (isRefreshAllBegin !== 0) {
            isRefreshAllCompleted(isRefreshAllBegin + 1);
        }
        loadingRefreshAll[NO_OF_POLLING_TOPIC - 1] = false;
        setRefreshGroup(false, fetchId);
        setIsRefreshSuccess(false);
    }

    const handleRefresh = () => {
        setRefreshFlg(true);
        setIsRefreshSuccess(false);
        const params = handleFetchParams();
        onRefresh(params);
    };

    const handleRefreshSuccess = (data: any) => {
        handleFetchSuccess(data, true);
        if (isRefreshAllBegin !== 0) {
            isRefreshAllCompleted(isRefreshAllBegin + 1);
        }
    }

    const refreshAll = () => {
        if (isRefreshAllBegin === NO_OF_POLLING_TOPIC) {
            console.log("start fetch all");
            console.log("fetch No:______" + isRefreshAllBegin);
            handleRefresh();
        }
        if (isRefreshGroup) {
            handleRefresh();
            setIsRefreshSuccess(false);
        }
        if (loadingRefreshAll[NO_OF_POLLING_TOPIC - 1] === true) {
            setIsRefreshSuccess(false);
        }
        isRefreshAllBegin > 0 || isRefreshGroup ? setRefreshFlg(true) : setRefreshFlg(false);
    }
    // eslint-disable-next-line
    React.useEffect(refreshAll, [isRefreshAllBegin, isRefreshGroup]);

    React.useEffect(() => {
        setDisabledRefreshGroupBtn(refreshFlg, fetchId);
        // eslint-disable-next-line
    }, [refreshFlg]);

    React.useEffect(() => {
        defaultData && handleFetchSuccess(defaultData, false);
        // eslint-disable-next-line
    }, [defaultData]);

    return (
        <>
            <Card style={{ margin: '0 auto 12px', backgroundColor: '#f5faff', width: '100%' }}>
                <CardHeader
                    avatar={
                        <PublishedWithChangesIcon style={isRefreshSuccess ? enableRefreshSuccessIconStyles : disabledRefreshSuccessIconStyles} />
                    }
                    action={
                        <div>
                            <IconButton aria-label="refresh" onClick={handleRefresh} disabled={isDisbleRefeshBtn || refreshFlg}>
                                <CachedIcon fontSize="medium" style={isDisbleRefeshBtn || refreshFlg ? disabledRefreshAllBtnStyle : enableRefreshAllBtnStyle} />
                            </IconButton>
                        </div>
                    }
                    title='デマンド現在値'
                    titleTypographyProps={{ variant: 'h5' }}
                />
                <CardContent style={{ padding: '0 0 16px 0' }}>
                    {(fetchState.loading || loadingRefreshAll[NO_OF_POLLING_TOPIC - 1] === true) ? (
                        <div style={{ display: 'flex', position: 'relative' }}>
                            <table className={'polling'} style={{ borderCollapse: 'collapse', width: '100%', margin: 'auto' }}>
                                <tbody>
                                    <tr>
                                        <td style={pollingColStyleTitle}>警報発生時間</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>現在電力</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>予測電力</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>限界電力</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>注意電力</td>
                                    </tr>
                                </tbody>
                            </table>
                            <div style={{ position: 'absolute', top: '40%', left: '60%' }}>
                                <CircularProgress style={{ margin: 'auto' }} />
                            </div>
                        </div>
                    ) : (
                        <table className={'polling'} style={{ borderCollapse: 'collapse', width: '100%', margin: 'auto' }}>
                            <tbody>
                                <tr>
                                    <td style={pollingColStyleTitle}>警報発生時間</td>
                                    <td style={pollingColStyle}>{demandCurrentData?.occurrenceTime}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>現在電力</td>
                                    <td style={pollingColStyle}>{demandCurrentData?.currentKw}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>予測電力</td>
                                    <td style={pollingColStyle}>{demandCurrentData?.predictKw}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>限界電力</td>
                                    <td style={pollingColStyle}>{demandCurrentData?.alarm2Kw}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>注意電力</td>
                                    <td style={pollingColStyle}>{demandCurrentData?.alarm1Kw}</td>
                                </tr>
                            </tbody>
                        </table>
                    )}
                    <Typography display='flex' justifyContent='flex-end' padding='4px 4px 0 0'>最終取得日時：{demandCurrentData?.lastGetDatetime ?? '-'}</Typography>
                </CardContent>
            </Card >
            <FetchHelper fetchId={fetchId} onComplete={(success, data, error) => success ? handleRefreshSuccess(data) : handleError(success, data, error)} />
        </>
    );
};
const mapStateToProps = (state: ApplicationState) => ({
    fetchState: selectors.getFetchState(
        state,
        fetchId
    ) as FetchState,
});
const mapDispatchToProps = {
    onRefresh: (params: any) => actionCreators.fetch(fetchId, `/polling/get`, "GET", params),
    onError: (success: boolean, data: any, error: any) =>
        actionCreators.showMessage({
            type: "error",
            title: "デマンド現在値取得",
            body: "デマンド現在値取得できません。",
        }),
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DemandCurrentData);


